import { getLanguageCode } from 'app/functions/string';
import fetch from 'isomorphic-fetch';

export const fetchCityRelationDetails = (url, fromCityId = null, toCityId = null, locale) => {
    const queryString = new URLSearchParams();

    queryString.set('locale', getLanguageCode(locale));
    queryString.set('from_city_id', fromCityId);
    queryString.set('to_city_id', toCityId);

    return fetch(`${url}?${queryString.toString()}`)
        .then(response => response.json());
};
